import { Injectable, OnInit } from '@angular/core';
import { PathLocationStrategy } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import {constants} from '../app-constants';
import {UsuarioLogadoModel, LoginParamModel, LoginResult, PrimeiroAcesso, PrimeiroAcessoResult} from '../model';
import {ClienteService} from './cliente.service';
import {Router} from '@angular/router';
import { CookieService } from 'ngx-cookie-service';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import {AdvGrowlService} from 'primeng-advanced-growl';

import { PropertiesLocales } from '../util/properties-locale';

@Injectable({ providedIn: 'root' })
export class AuthenticationService implements OnInit {

  private httpOptions = constants.httpDefaultOptions;
  private pathOSWS = `/WS/rest/PortalCliente`;
  public properties: PropertiesLocales = new PropertiesLocales();
  public message: any;
  public usuarioLogado: UsuarioLogadoModel = new UsuarioLogadoModel;
  public basePath: string;
  public uri: string;

  constructor(private http: HttpClient,
            private clienteService: ClienteService,
            private advGrowlService: AdvGrowlService,
            private router: Router,
            private cookieService: CookieService,
            private loadingBar: NgxUiLoaderService) {
    let local = localStorage.getItem(constants.locale);
    this.uri =  window.location.pathname;  // this.basePath.substring(7).replace('/', '').toString();
    this.uri = this.uri.substring(7).replace('/', '').toString();

    if (!local.match(this.uri)) { // prevalece o locale definido na URL
      local = this.uri.replace('/', '');
    }

    switch (local) {
      case 'es':
        this.message = this.properties.items_steps_es;
        break;
      case 'en':
        this.message = this.properties.items_steps_en;
        break;
      default:
        this.message = this.properties.items_steps_pt;
        break;
    }
  }

  ngOnInit() {
    let local = localStorage.getItem(constants.locale);
    this.uri =  window.location.pathname;  // this.basePath.substring(7).replace('/', '').toString();
    this.uri = this.uri.substring(7).replace('/', '').toString();

    if (!local.match(this.uri)) { // prevalece o locale definido na URL
      local = this.uri.replace('/', '');
    }

    switch (local) {
      case 'es':
        this.message = this.properties.items_steps_es;
      break;
      case 'en':
      this.message = this.properties.items_steps_en;
      break;
      default:
      this.message = this.properties.items_steps_pt;
      break;
    }
  }

  firstAccess(primeiroAcesso: PrimeiroAcesso) {
    this.loadingBar.start();
    this.http.post<PrimeiroAcessoResult>(`${this.pathOSWS}/createAccout/v1`, JSON.stringify(primeiroAcesso), this.httpOptions)
      .subscribe(result =>  {
        if (result && result.sucesso) {
          constants.authorization = result.token;
          this.usuarioLogado.idEmpresa = primeiroAcesso.idEmpresa;
          this.usuarioLogado.token = result.token;
          this.loadingBar.stop();
          localStorage.setItem(constants.usuarioLogadoKey, JSON.stringify(this.usuarioLogado));
          this.advGrowlService.createSuccessMessage(this.message[15].msg_service_success_firstaccess, this.message[14].msg_service_success);
        } else {
          const msg = this.message[17].msg_service_failed_firstaccess;
          this.advGrowlService.createTimedErrorMessage(msg, this.message[16].msg_service_failed, 3000);
          this.loadingBar.stop();
        }
    });
  }

  login(loginParam: LoginParamModel) {
    this.loadingBar.start();
    this.http.post<LoginResult>(`${this.pathOSWS}/Login/v1`, JSON.stringify(loginParam), this.httpOptions)
      .subscribe(loginResult => {
        // login successful if there's a jwt token in the response
        if (loginResult && loginResult.sucesso && loginResult.token) {
          const token = loginResult.token;
          this.usuarioLogado.idEmpresa = loginParam.idEmpresa;
          this.usuarioLogado.token = token;
          localStorage.setItem(constants.usuarioLogadoKey, JSON.stringify(this.usuarioLogado));
          localStorage.setItem(constants.locale, this.cookieService.get('locale'));

          this.clienteService.getCliente()
            .subscribe(clienteResult => {
              if ( clienteResult !== undefined) {
                this.usuarioLogado.nome = clienteResult.cliente.nomeTitular;
                localStorage.setItem(constants.clienteKey, JSON.stringify(clienteResult.cliente));
                localStorage.setItem(constants.usuarioLogadoKey, JSON.stringify(this.usuarioLogado));
                this.router.navigate(['/listaOrdemServico']);
                this.loadingBar.stop();
                setTimeout(() => window.location.reload());
              }
            });
        } else {
          this.advGrowlService.createTimedErrorMessage(loginResult.erros[0].description, 'Error ::' + loginResult.erros[0].code, 3000);
          this.loadingBar.stop();
        }
      });
  }

  logout() {
    this.usuarioLogado = JSON.parse(localStorage.getItem(constants.usuarioLogadoKey));

    let varIdEmpresa;
    if ( this.usuarioLogado && this.usuarioLogado.idEmpresa ) {
      varIdEmpresa = this.usuarioLogado.idEmpresa;
      this.cookieService.set( 'idEmpresa', varIdEmpresa);
    }

    localStorage.clear();
    this.router.navigate(['/login'], { queryParams: { idEmpresa: this.cookieService.get('idEmpresa') } });
    setTimeout(() => window.location.reload());
  }

}
